export default __webpack_public_path__ + "static/media/deductionCoin.57f621e6.svg";